const tables = [
  {
    name: "Date",
  },
  {
    name: "Role",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
